import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import Border from '../components/border'
import Header_Container from '../components/Header_Container'
import Footer from '../components/footer'


import '../sass/main.scss'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="ShiKai || personal site"
      meta={[
        { name: 'description', content: 'this is the personal portfolio site' },
        { name: 'keywords', content: 'personal site, portfolio,ShiKai' },
      ]}
    />
     <meta  name="viewport" content="width=device-width, initial-scale=1, user-scalable=no"/>
     <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.css" />
OXf9hH6QRxi0+EODezv82DfnZoV7qoHAZDwMwEJvSw"
  crossorigin="anonymous" />
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0-beta.2/css/bootstrap.min.css"/>
    <Header_Container/>
    <div>
      {children()}
    </div>
   <Border/>
   <Footer/>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js